import MdButton from "./MdButton"

const MdButtonPlugin = {
  install(app) {
    app.component(MdButton.name, MdButton)
  },
}

export default MdButtonPlugin
